import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { getVendorName } from "../../../utils/getVendorName";
import { useBulkInsertPaymentTransferFromFileMutation } from "../../../features/tenant/paymentTransfer/paymentTransferApi";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";
import CSVReader from "../../../components/ImportCsv/CSVReader";


const UploadPaymentTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [date, setDate] = useState(null);
  const [csvData, setCSVData] = useState([]);
  const [fileName, setFileName] = useState(null);

  const [
    bulkInsertPaymentTransferFromFile,
    {
      data: fileUploadData,
      error: fileUploadError,
      isLoading: fileUploadIsLoading,
    },
  ] = useBulkInsertPaymentTransferFromFileMutation();


  const handleFileUploadSubmit = (e) => {
    e.preventDefault();

    if (!csvData || !csvData.file) {
      toast.error("Please select a CSV file first");
      return;
    }

    if (!date) {
      toast.error("Please select month and year");
      return;
    }

    toast.loading("Uploading and processing file...");

    bulkInsertPaymentTransferFromFile({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      file: csvData.file,
      month: new Date(date).getMonth().toString(),
      year: new Date(date).getFullYear().toString(),
    });
  };

  // Handle file upload responses
  useEffect(() => {
    if (fileUploadData) {
      toast.dismiss();

      if (fileUploadData.success && fileUploadData.body) {
        const { totalRows, processedRows, skippedRows, batchId, fileName } = fileUploadData.body;
        let message = `File uploaded successfully! Processed ${processedRows} out of ${totalRows} rows`;
        if (skippedRows > 0) {
          message += ` (${skippedRows} rows skipped)`;
        }

        toast.success(message, {
          id: "fileUploadSuccess",
        });

        setTimeout(() => {
          navigate(`/genefied/${getVendorName()}/payment-transfer`);
        }, 400);
      } else {
        toast.error(fileUploadData.message || "File upload failed", {
          id: "fileUploadError",
        });
      }

      console.log("File Upload data", fileUploadData);
    }

    if (fileUploadError) {
      toast.dismiss();

      if (fileUploadError.status === 409) {
        toast.error("This file has already been uploaded", {
          id: "fileUploadDuplicateError",
        });
      } else if (fileUploadError.status === 400) {
        const errorData = fileUploadError.data;
        if (errorData && errorData.data && errorData.data.invalidRows) {
          const { invalidRows, totalRows, validRows, invalidRowsCount } = errorData.data;
          let message = `Validation failed: ${invalidRowsCount} out of ${totalRows} rows have errors`;

          // Show first few errors as examples
          if (invalidRows && invalidRows.length > 0) {
            const firstError = invalidRows[0];
            if (firstError.errors && firstError.errors.length > 0) {
              message += `. Example: ${firstError.errors[0]}`;
            }
          }

          toast.error(message, {
            id: "fileUploadValidationError",
            duration: 8000,
          });
        } else if (errorData && errorData.data && errorData.data.missingColumns) {
          toast.error(`Missing required columns: ${errorData.data.missingColumns.join(", ")}`, {
            id: "fileUploadMissingColumnsError",
          });
        } else {
          toast.error(errorData?.message || "Bad Request - Please check your file format", {
            id: "fileUploadBadRequestError",
          });
        }
      } else {
        toast.error("File upload failed. Please try again.", {
          id: "fileUploadGenericError",
        });
      }

      console.log("File Upload error", fileUploadError);
    }
  }, [fileUploadData, fileUploadError]);

  // console.log(sortedData);

  console.log("filename", fileName);

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Upload Payment Transfer
            <LinksComponent />
          </div>

          <div className="mx-auto px-6 py-4">
            <div className="bg-white mx-auto max-w-3xl rounded-lg shadow-sm border border-gray-200 p-6 mb-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Need a template?</h3>
                  <p className="text-sm text-gray-600">Download our sample CSV file to see the required format</p>
                </div>
                <button
                  type="button"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                  onClick={() =>
                    downloadSampleCSV(
                      JSON.parse(sessionStorage.getItem("vendorData"))
                        .tenant_id == 13
                        ? [
                          { name: "mobile" },
                          { name: "name" },
                          { name: "amount" },
                          { name: "upi_mobile" },
                          { name: "request_id" },

                        ]
                        : [
                          { name: "emp_id" },
                          { name: "name" },
                          { name: "l1_manager" },
                          { name: "amount" },
                        ]
                    )
                  }
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Download Sample CSV
                </button>
              </div>
            </div>

            {/* Main Upload Section */}
            <div className="bg-white mx-auto max-w-3xl rounded-lg shadow-sm border border-gray-200 p-4">
              <div className="text-center mb-4">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">Upload Payment Transfer File</h2>
                {/* <p className="text-gray-600 max-w-2xl mx-auto">
                  Upload your CSV file 
                  for direct server-side processing with advanced validation and duplicate prevention. 
                  All data will be validated before processing to ensure accuracy.
                </p> */}
              </div>

              <form className="space-y-6">
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                  <label htmlFor="monthYearInput" className="text-sm font-medium text-gray-700 whitespace-nowrap">
                    Select Period:
                  </label>
                  <div className="flex-1 max-w-xs">
                    <input
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      type="month"
                      id="monthYearInput"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      required
                    />
                  </div>
                  {!date && (
                    <p className="text-sm text-red-600">Please select month and year</p>
                  )}
                </div>

                {/* File Upload Area */}
                <div className="space-y-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Upload CSV File
                  </label>

                  <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center">
                    <div className="flex-1">
                      <CSVReader setCSVData={setCSVData} setFileName={setFileName} />
                    </div>

                    {/* Upload Button */}
                    {csvData && csvData?.file && (
                      <div className="flex flex-col sm:flex-row gap-3">
                        <button
                          type="button"
                          onClick={(e) => handleFileUploadSubmit(e)}
                          disabled={fileUploadIsLoading || !date}
                          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                        >
                          {fileUploadIsLoading ? (
                            <>
                              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            <>
                              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                              </svg>
                              Upload File
                            </>
                          )}
                        </button>
                      </div>
                    )}
                  </div>

                  {/* File Info Display */}
                  {csvData && csvData?.file && (
                    <div className="bg-blue-50 border border-blue-200 rounded-md p-2">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div className="flex-1">
                          <p className="text-sm font-medium text-blue-900">File Ready for Upload</p>
                          <p className="text-sm text-blue-700">{csvData.file.name}</p>
                        </div>
                        <div className="text-sm text-blue-600">
                          {Math.round(csvData.file.size / 1024)} KB
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Instructions */}
                <div className="bg-gray-50 rounded-md p-3">
                  <h4 className="text-sm font-medium text-gray-900 mb-2">Upload Instructions:</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Ensure your CSV file contains the required columns</li>
                    <li>• File will be validated for data integrity and format</li>
                    <li>• Duplicate files will be rejected automatically</li>
                    <li>• Processing may take a few moments for large files</li>
                  </ul>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadPaymentTransfer;
